import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "ProviChat",
  "use": "ProviChat-usage",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" id=\"ProviChat\">\n  <path d=\"M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol